import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContainerVm, ResourceVm } from 'qp-ui-interface';
import { CarouselStyle, CarouselType } from '../../shared/shared-components/cards-carousel/model/cards-carousel-models';
import { getCarouselType } from '../../shared/utils/cardsCarouselUtils';
import { EpisodesPage, EpisodesService } from 'src/app/shared/services/episodes/episodes.service';
import { PlayerDialogData } from '../interfaces/dialogs.interface';
import { TranslateService } from '@ngx-translate/core';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';

@Component({
  selector: 'app-player-episodes',
  templateUrl: './player-episodes.component.html',
  styleUrls: ['./player-episodes.component.scss'],
})
export class PlayerEpisodesComponent implements OnInit {
  seasons?: ResourceVm[];
  episodes?: ContainerVm;
  selectedSeason?: number;
  seasonEpisodesPagination: EpisodesPage[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: PlayerDialogData,
    private readonly dialogRef: MatDialogRef<PlayerEpisodesComponent>,
    private readonly episodesService: EpisodesService,
    private translate: TranslateService,
    private navService: NavigationLibraryService
  ) {
    //
  }

  ngOnInit(): void {
    this.episodesService.pageSize = 10;
    this.fetchSeries();
  }

  fetchSeries(): void {
    this.episodesService.fetchSeries(this.data.currentResource).then((res) => {
      this.navService.focusPage('focusable-container');
      this.seasons = res?.seasons;
      this.episodes = res?.episodes;
      this.selectedSeason = res?.currentSeason?.seasonNumber;
      if (res) {
        this.manageEpisodes();
      }
    });
  }

  getCarouselType(container: ContainerVm): CarouselType {
    return getCarouselType(container);
  }

  close(): void {
    this.dialogRef.close();
  }

  async getNextPage(index: number): Promise<void> {
    const currentEpisodesSize = this.episodes?.resources?.length || 0;
    if (currentEpisodesSize >= this.episodes.totalItems) {
      return; // Pagination completed
    }

    const nearEndThreshold = currentEpisodesSize - 5; // 5 cards before end
    if (index === nearEndThreshold) {
      const nextPage = this.seasonEpisodesPagination.shift();
      if (!nextPage) {
        return; // Pagination completed
      }
      const newEpisodes = await this.episodesService.getEpisodesPage(nextPage.seriesId, nextPage.seasonId, nextPage.pageNumber + 1);
      if (newEpisodes?.resources) {
        this.episodes.resources.push(...newEpisodes.resources);
      }
    }
  }

  private manageEpisodes = () => {
    if (this.episodes) {
      this.data.currentResource.episodesCount = this.episodes.totalItems;
      this.data.currentResource.episodes = this.episodes.resources;
      this.episodes.sourceType = CarouselStyle.PLAYER_EPISODES;
      this.episodes.name = this.translate.instant('player.episodes');
      this.seasonEpisodesPagination = this.episodesService.pagination;
      this.seasonEpisodesPagination.shift();
    }
  };
}
